import React, { Component } from 'react';

import PropTypes from 'prop-types';

import SearchBar from '../search/search-bar/index';

import { LoadingIndicator } from '../../components';
import Group from './group';
import env from '../../../run-config';

class Checklists extends Component {
  constructor(props) {
    super(props);

    this.checklistBaseUrl = this.props.checklistUrl || this.props.match.url;
    this.state = {};
    this.onSearch = this.onSearch.bind(this);
    this.onClickShare = this.onClickShare.bind(this);
  }

  componentDidMount() {
    this.props.onLoadChecklists();
    this.props.onLoadChecklistDueDates();
  }

  onSearch(searchTerm) {
    this.props.navigate(`/search?searchTerm=${searchTerm}`);
  }

  onClickChecklist(checklist) {
    this.props.selectChecklist(checklist);
    this.props.history.push(
      `${this.props.checklistUrl || this.props.match.url}/${checklist.id}`
    );
  }
  onClickChecklistRun(checklist, checklistRun) {
    var params = {checklist,checklistRun };
    this.props.selectChecklistRun(params);
    this.props.history.push(
      `${this.props.checklistUrl || this.props.match.url}/${
        checklistRun.checklistId
      }`
    );
  }

  renderChecklistGroups(data) {
    return data.map((group) => (
      <Group
        key={group.id}
        group={group}
        pinOrUnpinContent={this.props.pinOrUnpinContent}
        onClick={this.onClickChecklist.bind(this)}
        onClickShare={this.onClickShare}
      />
    ));
  }

  onClickShare(checklist) {
    const url = `${env.apiHost}/checklists/${checklist.id}/all`;
    this.props.onExportContent(url);
  }
  renderLastRuns() {
    const lastChecklistRunsChecklists = [];
    const lastChecklistRuns = this.props.checklistRuns.filter(
      (c) => c.endDate != null
    );
    lastChecklistRuns.forEach((c) => {
      let checklistForRun = this.props.checklists.filter(
        (t) => t.id == c.checklistId
      )[0];
      //checklistForRun.lastRun = c;
      lastChecklistRunsChecklists.push(checklistForRun);
    });
    const lastRunGroup = {
      id: 0,
      children: lastChecklistRunsChecklists,
      name: 'Letzte Durchläufe',
      checklistRuns: lastChecklistRuns,
    };
    return (
      <Group
        key={lastRunGroup.id}
        group={lastRunGroup}
        onClick={this.onClickChecklistRun.bind(this)}
        onClickShare={this.onClickShare}
      />
    );
  }
  renderDueChecklists() {
    const dueGroup = {
      name: 'Fällige Checklisten',
      children: this.props.dueChecklists,
      checklistDueDates: this.props.checklistDueDates,
    };
    return (
      <Group
        group={dueGroup}
        onClick={this.onClickChecklist.bind(this)}
        onClickShare={this.onClickShare}
      />
    );
  }

  render() {
    if (this.props.isLoading) {
      return <LoadingIndicator show centered />;
    }

    if (!this.props.checklists) {
      return null;
    }

    const topLevelChecklists = this.props.checklists.filter(
      (c) => c.type == 'checklist'
    );
    const data = this.props.checklists
      .asMutable()
      .filter(
        (t) => t.type == 'checklistGroup' && t.children && t.children.length
      );

    if (topLevelChecklists.length) {
      data.push({ name: 'Weitere Checklisten', children: topLevelChecklists });
    }

    const searchBar = !this.props.disableSearch ? (
      <SearchBar location={this.props.location} onSearch={this.onSearch} />
    ) : null;

    return (
      // <div className="col-lg-10 col-md-12 col-sm-12">
      <div>
        {searchBar}
        {this.renderDueChecklists()}
        {this.renderChecklistGroups(data)}
        {this.renderLastRuns()}
      </div>
    );
  }
}

Checklists.propTypes = {
  checklists: PropTypes.array,
  isLoading: PropTypes.bool,
  onLoadChecklists: PropTypes.func,
  onLoadChecklistDueDates: PropTypes.func,
  dueGroup: PropTypes.object,
  onExportContent: PropTypes.func,
  onStartNewChecklistRun: PropTypes.func,
  onPinOrUnpinContent: PropTypes.func,
  checklistUrl: PropTypes.string,
  disableSearch: PropTypes.bool,
  location: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
  checklistRuns: PropTypes.array,
  checklistsToDos: PropTypes.array,
  startNewChecklistRun: PropTypes.func,
  pinOrUnpinContent: PropTypes.func,
  navigate: PropTypes.func,
  selectChecklist: PropTypes.func,
  selectChecklistRun: PropTypes.func,
  dueChecklists: PropTypes.array,
};
Checklists.defaultProps = {
  groups: [],
  isLoading: false,
  checklistDueDates: null,
  dueChecklists: [],
};

export default Checklists;



// WEBPACK FOOTER //
// ./src/app/main/checklists/checklists.js